import $ from "jquery";

const contacts = () => {
    if ($('#map').length) {

        // Получаем контент с сервера.
        const getResource = async function(url) {
            const result = await fetch(url);

            if (!result.ok) {
                throw new Error(`Сould not fetch ${url}, status ${result.status}`);
            }

            return await result.json(); // Это промис
        };

        // функция генерации контента
        const getCityInfo = (city, response) => {
            const item = response.find(elem => elem.city == city);
            const {map, shops} = item;

            // название города в скрытое поле, для обратной связи
            $('#city').val(item.city);

            ymaps.ready(init);

            function init() {
                // Создание карты.
                let myMap = new ymaps.Map("map", {
                    center: map,
                    zoom: 12,
                    controls: ['zoomControl']
                });

                shops.forEach(item => {
                    let myPlacemark = new ymaps.Placemark(item.coords, {}, {
                        iconLayout: 'default#image',
                        iconImageHref: './img/icons/map-mark.png',
                        iconImageSize: [55, 57],
                        iconImageOffset: [-28, -45]
                    })

                    myMap.geoObjects.add(myPlacemark);
                })

                myMap.behaviors.disable('scrollZoom');
                if (shops.length > 1) {
                    myMap.setBounds(myMap.geoObjects.getBounds());
                } else {
                    myMap.setCenter(shops[0].coords);
                }
            }

            // вставка магазинов
            shops.forEach(elem => {
                // если несколько телефонов
                let phoneArr = elem.phone.split(',');
                let phones = '';
                if (phoneArr.length > 1) {
                    $.each(phoneArr, function (index, value) {
                        phones += `<a href="tel:${value}" className="phone">${value}</a>`;
                    });
                }
                if (phoneArr.length == 1) {
                    phones = `<a href="tel:${elem.phone}" className="phone">${elem.phone}</a>`
                }

                let shop = (
                    `<div class="item">
                        <div class="head">
                            <p class="name">${elem.name}</p>
                            <span class="type">${elem.type}</span>
                        </div>
                        <div class="content">
                            <p class="address">${elem.address}</p>
                            ${phones}
                            <a href="mailto:${elem.mail}" class="mail">${elem.mail}</a>
                            <p class="time">${elem.time}</p>
                            ${elem.has_parking ? '<p class="parking">Есть парковка</p>' : ''}
                        </div>
                    </div>`
                )

                $('.contacts__list').append(shop);
            })

            //Убираем прелоадеры
            $('.contacts__map').removeClass('loading');
            $('.contacts__list').removeClass('loading');

        }

        //Первоначальная подгрузка


        getResource('/contacts/json')
            .then(result => {
                let activeCity = $('.tabs__item.active').text().trim();
                getCityInfo(activeCity, result)
            })

        //Клик по табам
        $('.tabs_map .tabs__item').click(function () {
            if (!$(this).hasClass('active')) {
                //Добавляем прелоадеры
                $('.contacts__map').addClass('loading');
                $('.contacts__list').addClass('loading');

                //очищаем контент
                $('#map').html('');
                $('.contacts__list').html('');

                $(this).addClass('active').siblings().removeClass('active');

                getResource('/contacts/json')
                    .then(result => {
                        let activeCity = $('.tabs__item.active').text().trim();
                        getCityInfo(activeCity, result)
                    })
            }

        })
    }

}

export default contacts;
